<template>
  <div class="editor-container">
        <quill-editor
          v-model="editorContent"
          :options="editorOptions"
          @blur="onEditorBlur"
          @change="onEditorChange"
          ref="quillEditor"
        />
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import axios from 'axios';

export default {
  name: 'rich-editor',
  components: { quillEditor },
  props: {
    value: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 300
    },
    placeholder: {
      type: String,
      default: '请输入内容...'
    },
    uploadUrl: {
      type: String,
      default: '/upload'
    },
    nodeContent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editorContent: this.value, // 绑定富文本内容
      editorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗、斜体、下划线、删除线
              ['blockquote', 'code-block'], // 引用、代码块
              [{ header: 1 }, { header: 2 }], // 标题
              [{ list: 'ordered' }, { list: 'bullet' }], // 有序列表、无序列表
              [{ script: 'sub' }, { script: 'super' }], // 下标、上标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ direction: 'rtl' }], // 文字方向
              [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题级别
              [{ color: [] }, { background: [] }], // 字体颜色、背景色
              [{ font: [] }], // 字体
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除格式
              ['link'], // 链接、图片 , 'image'
            ],
            handlers: {
              image: this.imageHandler
            }
          }
        },
        placeholder: this.placeholder,
        theme: 'snow', // 主题风格：snow（默认）、bubble
      },
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== this.editorContent) {
        this.editorContent = newVal;
      }
    },
    // 监听节点内容变化，动态更新编辑器内容
    nodeContent: {
      handler(newContent) {
        if (newContent && newContent !== this.editorContent) {
          this.editorContent = newContent;
          // 确保编辑器内容已更新
          this.$nextTick(() => {
            if (this.$refs.quillEditor) {
              const quill = this.$refs.quillEditor.quill;
              quill.focus();
            }
          });
        }
      },
      immediate: true
    }
  },
  mounted() {
    // 确保图片处理器能够访问组件实例
    this.editorOptions.modules.toolbar.handlers.image = this.imageHandler;
  },
  methods: {
    // 设置编辑器内容的方法，可以被父组件调用
    setContent(content) {
      this.editorContent = content;
    },
    onEditorBlur() {
      // 编辑器失焦时的回调
      this.$emit('blur', this.editorContent);
      // 父组件可以通过@blur事件监听器接收编辑器内容
      // 例如：<editor :value="content" @blur="handleEditorBlur"></editor>
      // 在父组件中定义handleEditorBlur(content) { this.content = content }
    },
    onEditorChange({ html }) {
      // 编辑器内容变化时的回调
      this.$emit('input', html);
      this.$emit('change', html);
    },
    imageHandler() {
      // 创建隐藏的文件输入框
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.click();
      
      // 监听文件选择事件
      input.onchange = async () => {
        const file = input.files[0];
        if (file) {
          try {
            // 显示上传中提示
            this.$message && this.$message({
              type: 'info',
              message: '图片上传中...'
            });
            
            // 创建表单数据
            const formData = new FormData();
            formData.append('file', file);
            
            // 调用上传接口
            const response = await axios.post(this.uploadUrl, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
            
            // 获取上传后的图片URL
            const url = response.data.url || response.data.data;
            
            // 获取编辑器实例和当前选择范围
            const quill = this.$refs.quillEditor.quill;
            const range = quill.getSelection();
            
            // 在光标位置插入图片
            quill.insertEmbed(range.index, 'image', url);
            // 将光标移动到图片后面
            quill.setSelection(range.index + 1);
            
            // 显示上传成功提示
            this.$message && this.$message({
              type: 'success',
              message: '图片上传成功'
            });
          } catch (error) {
            console.error('图片上传失败:', error);
            this.$message && this.$message({
              type: 'error',
              message: '图片上传失败，请重试'
            });
          }
        }
      };
    }
  }
};
</script>

<style scoped>
/deep/ .ql-editor {
  min-height: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editor.vue